import { render, staticRenderFns } from "./ConfirmSensitiveContentView.vue?vue&type=template&id=669e1a8c&"
import script from "./ConfirmSensitiveContentView.vue?vue&type=script&lang=ts&"
export * from "./ConfirmSensitiveContentView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports